/**
 * Tab index maps for ResponsibilityCard — kept pure for unit tests and LD flag wiring.
 * @param {boolean} showAttachedRolesTab idea-MDP-464
 * @param {boolean} showContextTab context-tab-responsibility-page
 * @returns {Record<string, number>}
 */
export function buildResponsibilityTabNameToIndex(showAttachedRolesTab, showContextTab) {
  const map = showAttachedRolesTab
    ? {
        checklist: 0,
        "badge-holders": 1,
        assignments: 2,
        "attached-roles": 3,
      }
    : {
        checklist: 0,
        "badge-holders": 1,
        assignments: 2,
      };

  let nextIndex = Object.keys(map).length;
  if (showContextTab) {
    map.purpose = nextIndex;
    map.context = nextIndex;
    nextIndex += 1;
  }
  map.defaults = nextIndex;
  return map;
}

/**
 * @param {Record<string, number>} tabNameToIndex
 * @returns {Record<number, string>}
 */
export function buildResponsibilityTabIndexToName(tabNameToIndex) {
  const byIndex = {};
  for (const [name, index] of Object.entries(tabNameToIndex)) {
    if (name === "context") continue;
    byIndex[index] = name;
  }
  return byIndex;
}

/**
 * @param {string|null|undefined} tabParam
 * @returns {string|null}
 */
export function normalizeResponsibilityRouteTabParam(tabParam) {
  if (tabParam == null || tabParam === "") return null;
  const t = String(tabParam).toLowerCase();
  if (t === "context") return "purpose";
  return t;
}

/**
 * Resolve selected tab index from route param and flag state.
 * @returns {{ index: number, redirectTo: string|null }}
 */
export function resolveResponsibilityTabFromRoute(
  tabParam,
  showAttachedRolesTab,
  showContextTab
) {
  const tabNameToIndex = buildResponsibilityTabNameToIndex(
    showAttachedRolesTab,
    showContextTab
  );
  const normalized = normalizeResponsibilityRouteTabParam(tabParam);
  if (!normalized) {
    return { index: tabNameToIndex.checklist ?? 0, redirectTo: null };
  }

  if (normalized === "attached-roles" && !showAttachedRolesTab) {
    return { index: tabNameToIndex.checklist ?? 0, redirectTo: "checklist" };
  }
  if ((normalized === "purpose" || normalized === "context") && !showContextTab) {
    return { index: tabNameToIndex.checklist ?? 0, redirectTo: "checklist" };
  }

  const idx = tabNameToIndex[normalized];
  if (idx !== undefined) {
    return { index: idx, redirectTo: null };
  }
  return { index: tabNameToIndex.checklist ?? 0, redirectTo: null };
}
